<div class="modal fade" id="esqueciaSenha" tabindex="-1" aria-labelledby="esqueciaSenha" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content advancedSearch-modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="esqueciaSenhaLabel">Esqueci a Senha</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="limparDados()"></button>
            </div>
            <form class="form-esqueci-senha">
                <div class="modal-body">
                    <div class="d-flex w-100 email-codigo-container">
                        <input 
                            type="text" 
                            class="form-input rounded px-4 py-2 flex-grow-1" 
                            placeholder="E-mail" 
                            id="email" 
                            name="email"
                            [(ngModel)]="esqueciSenhaModel.email"
                            [readonly]="emailBloqueado">
                        
                        <button 
                            id="procurarEmailCliente" 
                            type="button" 
                            class="btn btn-secondary ms-2 email-action-button btn-sm"
                            (click)="gerarCodigoRecuperacao()" 
                            [disabled]="processandoRecuperacao || mostrarCamposCodigo">
                            {{processandoRecuperacao ? 'Aguarde...' : 'Gerar código'}}
                        </button>
                    </div>
                    <div id="code" style="display: none;">
                        <input style="margin-bottom: 15px;" type="text" class="form-control mt-3 rounded" 
                               placeholder="Digite o código de recuperação enviado para seu email" 
                               name="icode" id="icode" [(ngModel)]="esqueciSenhaModel.code">
                        <div class="d-flex align-items-center justify-content-end mb-3 reenviar-container">
                            <div *ngIf="contadorAtivo" class="contador-reenvio text-muted small">
                                <span>Reenviar código em: {{ minutos }}:{{ segundos < 10 ? '0' + segundos : segundos }}</span>
                            </div>
                            <button *ngIf="!contadorAtivo" 
                                    type="button" 
                                    class="btn btn-link p-0 text-decoration-none small" 
                                    (click)="reenviarCodigo()"
                                    [disabled]="processandoReenvio">
                                {{ processandoReenvio ? 'Reenviando...' : 'Reenviar código' }}
                            </button>
                        </div>
                        <div class="position-relative mb-3">
                            <label for="senha">Nova Senha:</label>
                            <div class="input-with-icon">
                                <input type="password" class="w-full form-input rounded px-4 py-2" 
                                    placeholder="Nova senha" id="senha" name="senha" 
                                    [(ngModel)]="esqueciSenhaModel.novaSenha">
                                <span class="password-info-icon" #senhaInfo>?</span>
                            </div>
                        </div>

                        <div class="position-relative">
                            <div class="input-with-icon">
                                <input type="password" class="w-full form-input rounded px-4 py-2" 
                                    placeholder="Confirme a nova senha" id="senha1" name="senha1" 
                                    [(ngModel)]="esqueciSenhaModel.repetirNovaSenha">
                                <span class="password-info-icon" #confirmaSenhaInfo>?</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button id="limparDados" type="button" class="btn btn-secondary btn-sm"
                            (click)="limparDados()">Limpar</button>
                    <button id="trocarSenha" type="button" class="btn btn-primary btn-sm"
                            [disabled]="!mostrarCamposCodigo || processandoRecuperacao"
                            (click)="trocarSenha()">
                        {{processandoRecuperacao ? 'Processando...' : 'Trocar Senha'}}
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>